/********************************
 **** Media Gallery: Show more
 *********************************/

;(() => {
  // Hide media items after the 4th and reset button
  const resetGallery = gallery => {
    const items = gallery.querySelectorAll(".product__media-item")
    items.forEach((item, index) => {
      if (index > 3) {
        item.classList.add("media-hide")
      } else {
        item.classList.remove("media-hide")
      }
    })

    const mediaGallery = gallery.closest("media-gallery")
    const btn = mediaGallery?.querySelector("#show-more-btn")
    const labelSpan = btn?.querySelector("span")
    if (labelSpan) labelSpan.textContent = "Show more"
    if (btn) btn.classList.remove("show-less")
  }

  // Count total items and toggle button visibility
  const toggleShowMoreButton = mediaGallery => {
    const gallery = mediaGallery.querySelector("ul")
    if (!gallery) return

    const totalItems = gallery.querySelectorAll(".product__media-item").length
    const showMoreContainer = mediaGallery.querySelector("#show-more-media")

    if (!showMoreContainer) return

    console.log("Total media items:", totalItems) // Debug

    if (totalItems <= 4) {
      showMoreContainer.classList.add("visually-hidden")
    } else {
      showMoreContainer.classList.remove("visually-hidden")
    }
  }

  // Reset all galleries
  const resetAllGalleries = () => {
    document.querySelectorAll("media-gallery ul").forEach(gallery => {
      resetGallery(gallery)
      toggleShowMoreButton(gallery.closest("media-gallery"))
    })
  }

  // Wait for media gallery to finish loading
  const waitForMediaUpdate = (callback, maxAttempts = 20) => {
    let attempts = 0
    const checkMedia = () => {
      const mediaGallery = document.querySelector("media-gallery")
      if (!mediaGallery) return

      const gallery = mediaGallery.querySelector("ul")
      const items = gallery?.querySelectorAll(".product__media-item")

      // If we have items OR timeout reached, run callback
      if (items?.length > 0 || attempts >= maxAttempts) {
        callback()
      } else {
        attempts++
        setTimeout(checkMedia, 100)
      }
    }
    checkMedia()
  }

  // Initialize event listeners
  const init = () => {
    // Show more button click handler
    document.addEventListener("click", e => {
      const btn = e.target.closest("#show-more-btn")
      if (!btn) return

      const labelSpan = btn.querySelector("span")
      const gallery = btn.closest("media-gallery")?.querySelector("ul")
      if (!gallery || !labelSpan) return

      const hiddenItems = gallery.querySelectorAll(".media-hide")
      if (hiddenItems.length) {
        hiddenItems.forEach(item => item.classList.remove("media-hide"))
        labelSpan.textContent = "Show less"
        btn.classList.add("show-less")
      } else {
        resetGallery(gallery)
        window.scrollTo({ top: 0, behavior: "smooth" })
      }
      setTimeout(() => toggleShowMoreButton(btn.closest("media-gallery")), 50)
    })

    // Hook into Dawn's product form variant change
    const productForm = document.querySelector("product-form")
    if (productForm) {
      // Listen for the form's built-in variant change
      productForm.addEventListener("variant:change", () => {
        waitForMediaUpdate(() => {
          resetAllGalleries()
          window.scrollTo({ top: 0, behavior: "smooth" })
        })
      })
    }

    // Fallback: Watch input[name="id"] changes
    document.addEventListener("change", e => {
      if (e.target.matches('input[name="id"]')) {
        waitForMediaUpdate(() => {
          resetAllGalleries()
          window.scrollTo({ top: 0, behavior: "smooth" })
        })
      }
    })

    // Watch product-form__input changes (swatches, etc.)
    document.addEventListener("change", e => {
      if (e.target.closest(".product-form__input, .product-form__selects")) {
        waitForMediaUpdate(() => {
          resetAllGalleries()
        })
      }
    })

    // MutationObserver for media gallery changes
    const observer = new MutationObserver(mutations => {
      let shouldReset = false
      mutations.forEach(mutation => {
        if (mutation.type === "childList") {
          mutation.addedNodes.forEach(node => {
            if (
              node.nodeType === 1 &&
              (node.matches?.(".product__media-item") ||
                node.querySelector?.(".product__media-item"))
            ) {
              shouldReset = true
            }
          })
        }
      })
      if (shouldReset) {
        setTimeout(resetAllGalleries, 100)
      }
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    })
  }

  // Run when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init)
  } else {
    init()
  }

  // Initial check
  setTimeout(() => {
    resetAllGalleries()
  }, 1000)
})()
